import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { staffRosterOverridesApi } from "@/api/staff/staff-roster-overrides-api";
import type {
  StaffRosterOverrideCreate,
  StaffRosterOverrideSearchParams,
  StaffRosterOverrideUpdate,
} from "@/types/staff/api-types/staff-roster-override-types";

export const useGetStaffRosterOverrides = (
  params: StaffRosterOverrideSearchParams,
  enabled: boolean
) =>
  useQuery({
    queryKey: ["staff-roster-overrides", params],
    queryFn: () => staffRosterOverridesApi.getAll(params),
    enabled,
  });

export const useCreateStaffRosterOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: StaffRosterOverrideCreate) =>
      staffRosterOverridesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff-roster-overrides"] });
      queryClient.invalidateQueries({ queryKey: ["appointments-availability"] });
    },
  });
};

export const useUpdateStaffRosterOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: StaffRosterOverrideUpdate;
    }) => staffRosterOverridesApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff-roster-overrides"] });
      queryClient.invalidateQueries({ queryKey: ["appointments-availability"] });
    },
  });
};

export const useDeleteStaffRosterOverride = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => staffRosterOverridesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff-roster-overrides"] });
      queryClient.invalidateQueries({ queryKey: ["appointments-availability"] });
    },
  });
};
